import React, { useState } from 'react';
import { ref, set, get, update } from 'firebase/database';
import { db } from '../firebase';

const MultiScreen = ({ onBack, onRoomReady, userName, setUserName }) => {
  const [mode, setMode] = useState(null); // 'create' or 'join'
  const [inputCode, setInputCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const generateCode = () => Math.floor(1000 + Math.random() * 9000).toString();
  const generateId = () => Math.random().toString(36).slice(2, 8);

  const handleCreate = async () => {
    if (!userName.trim()) return setError('名前を入力してください');
    setLoading(true);
    const code = generateCode();
    const hostId = generateId();
    await set(ref(db, `multiRooms/${code}`), {
      host: hostId,
      status: 'lobby',
      currentIndex: 0,
      genreId: null,
      sectionId: null,
      questions: [],
      players: {
        [hostId]: { name: userName, isHost: true }
      },
      createdAt: Date.now(),
    });
    onRoomReady({ code, myId: hostId, isHost: true });
  };

  const handleJoin = async () => {
    if (!userName.trim()) return setError('名前を入力してください');
    if (inputCode.length !== 4) return setError('4桁のコードを入力してください');
    setLoading(true);
    const snap = await get(ref(db, `multiRooms/${inputCode}`));
    if (!snap.exists()) {
      setError('ルームが見つかりません');
      setLoading(false);
      return;
    }
    const data = snap.val();
    if (data.status !== 'lobby') {
      setError('このルームはすでに開始しています');
      setLoading(false);
      return;
    }
    const myId = generateId();
    await update(ref(db, `multiRooms/${inputCode}/players`), {
      [myId]: { name: userName, isHost: false }
    });
    onRoomReady({ code: inputCode, myId, isHost: false });
  };

  return (
    <div className="glass-card" style={{ maxWidth: '440px', width: '95%' }}>
      <h2 style={{ color: '#2c3e50', marginBottom: '6px' }}>👥 みんなで学習</h2>
      <p style={{ color: '#95a5a6', fontSize: '0.85rem', marginBottom: '24px' }}>
        ルームを作って友達と一緒に勉強しよう
      </p>

      {/* 名前入力 */}
      <div style={{ marginBottom: '16px', width: '100%' }}>
        <label style={{ fontSize: '0.8rem', color: '#7f8c8d', display: 'block', marginBottom: '6px' }}>
          あなたの名前
        </label>
        <input
          type="text"
          value={userName}
          onChange={e => setUserName(e.target.value)}
          placeholder="名前を入力"
          maxLength={10}
          style={{
            width: '100%', padding: '12px', borderRadius: '12px',
            border: '2px solid #e1e8ed', fontSize: '1rem',
            boxSizing: 'border-box', outline: 'none'
          }}
        />
      </div>

      {error && (
        <p style={{ color: '#e74c3c', fontSize: '0.8rem', marginBottom: '10px' }}>{error}</p>
      )}

      {!mode && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
          <button className="playful-btn" onClick={() => { setMode('create'); setError(''); }}>
            ルームを作る
          </button>
          <button className="playful-btn" style={{ background: '#2ecc71' }}
            onClick={() => { setMode('join'); setError(''); }}>
            ルームに参加する
          </button>
        </div>
      )}

      {mode === 'create' && (
        <div style={{ width: '100%' }}>
          <p style={{ color: '#7f8c8d', fontSize: '0.85rem', marginBottom: '16px' }}>
            ルームを作成して、表示されるコードを友達に共有してください
          </p>
          <button className="playful-btn" onClick={handleCreate} disabled={loading} style={{ width: '100%' }}>
            {loading ? '作成中...' : 'ルームを作成'}
          </button>
          <button onClick={() => setMode(null)}
            style={{ marginTop: '10px', background: 'none', border: 'none', color: '#95a5a6', cursor: 'pointer', width: '100%' }}>
            ← 戻る
          </button>
        </div>
      )}

      {mode === 'join' && (
        <div style={{ width: '100%' }}>
          <label style={{ fontSize: '0.8rem', color: '#7f8c8d', display: 'block', marginBottom: '6px' }}>
            ルームコード（4桁）
          </label>
          <input
            type="text"
            value={inputCode}
            onChange={e => setInputCode(e.target.value.replace(/\D/g, '').slice(0, 4))}
            placeholder="1234"
            style={{
              width: '100%', padding: '12px', borderRadius: '12px',
              border: '2px solid #e1e8ed', fontSize: '1.8rem',
              textAlign: 'center', letterSpacing: '0.3em',
              boxSizing: 'border-box', outline: 'none', marginBottom: '12px'
            }}
          />
          <button className="playful-btn" onClick={handleJoin} disabled={loading} style={{ width: '100%', background: '#2ecc71' }}>
            {loading ? '参加中...' : '参加する'}
          </button>
          <button onClick={() => setMode(null)}
            style={{ marginTop: '10px', background: 'none', border: 'none', color: '#95a5a6', cursor: 'pointer', width: '100%' }}>
            ← 戻る
          </button>
        </div>
      )}

      <button onClick={onBack}
        style={{ marginTop: '20px', background: 'none', border: 'none', color: '#bdc3c7', cursor: 'pointer', fontSize: '0.85rem' }}>
        タイトルに戻る
      </button>
    </div>
  );
};

export default MultiScreen;